var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('li',{staticClass:"content-list-item"},[_c('DottedLine',{staticClass:"vertical-dots"}),_c('h2',{staticClass:"content-list-item__heading"},[_vm._v(_vm._s(_vm.heading))]),_c('p',{staticClass:"content-list-item__content"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }